export const api = state => state.api;
export const user = state => state.user;
export const info = state => state.info;
export const expiration = state => state.expiration;
export const uuid = state => state.uuid;
